module.exports = __webpack_public_path__ + "img/moldex_logo.f10aee0a.png";